<template>
    <div class="accountRateFlowers__container container mx-auto text-center" :class="addressClass">
        <subscription-dropdown
            v-if="showDropdown"
            :label="$t('DELIVERY_CARD_DELIVERY')"
            class="pb-4"/>

        <div v-else>
            <h5 class="uppercase mb-1" v-text="$t('DELIVERY_CARD_DELIVERY')"></h5>
            <p class="w-full sm:w-2/3 mx-auto">
                {{houseNumber}}
                {{ address.address1 }}
            </p>
        </div>
    </div>
</template>

<script>
import SubscriptionDropdown from '@/components/partials/account/rate-my-flowers/SubscriptionDropdown';

export default {
    name: 'DeliveryScheduleAddress',
    components: {
        SubscriptionDropdown,
    },
    props: {
        address: {},
        showDropdown: {
            required: true,
            type: Boolean,
        },
        addressClass: {
            default: '',
            type: String,
        },
    },
    computed: {
        houseNumber() {
            return this.address?.houseNumber;
        },
    },
};
</script>
